/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Replace_QuestionInputs */

const en_faq_replace_question = /** @type {(inputs: Faq_Replace_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do we need to replace our existing software?`)
};

const lv_faq_replace_question = /** @type {(inputs: Faq_Replace_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai mums jāaizstāj esošā programmatūra?`)
};

/**
* | output |
* | --- |
* | "Do we need to replace our existing software?" |
*
* @param {Faq_Replace_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_replace_question = /** @type {((inputs?: Faq_Replace_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Replace_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_replace_question(inputs)
	return en_faq_replace_question(inputs)
});